class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    FacetFiltersForm.hadnlePriceRangeEvent()
  }

   static hadnlePriceRangeEvent() {
    let sliderTrack = document.querySelector(".range-slider-track");

    let rangeSliders = document.querySelectorAll('.range-slider-container input')
    let sliderMaxValue = rangeSliders[1].max;
    let rangeInputs = document.querySelectorAll('.rander-slider-values input[type=number]')

    rangeSliders.forEach((input, index) => input.addEventListener('input', e => {
        rangeInputs[index].value = input.value
        if(index === 0){
            FacetFiltersForm.rangeSliderHandler(rangeSliders, rangeSliders[0], rangeSliders[1])
            FacetFiltersForm.filterGTE(rangeSliders[0].value)

        } else {
            FacetFiltersForm.rangeSliderHandler(rangeSliders, rangeSliders[1], rangeSliders[0])
            FacetFiltersForm.filterLTE(rangeSliders[1].value)
        } 
    }))

    rangeInputs.forEach((input, index) => input.addEventListener('input', e => {
        rangeSliders[index].value = input.value
        if(index === 0){
            FacetFiltersForm.rangeSliderHandler(rangeSliders, rangeSliders[0], rangeSliders[1])
            FacetFiltersForm.filterGTE(rangeSliders[0].value)
        } else {
            FacetFiltersForm.rangeSliderHandler(rangeSliders, rangeSliders[1], rangeSliders[0])
            FacetFiltersForm.filterLTE(rangeSliders[1].value)
        } 
    }))
  }

  static filterGTE(x){
    if(screen.width >= 769) document.getElementById("Filter-Price-GTE").value = x
    else document.getElementById("Mobile-Filter-Price-GTE").value = x
  }
  static filterLTE(x){
    if(screen.width >= 769) document.getElementById("Filter-Price-LTE").value = x
    else document.getElementById("Mobile-Filter-Price-LTE").value = x
  }

  static rangeSliderHandler(rangeSliders, sliderX, sliderY) {
      if (parseInt(rangeSliders[1].value) - parseInt(rangeSliders[0].value) <= 0)
          sliderX.value = parseInt(sliderY.value) - 0;

      sliderX.classList.add('active-range-circle')
      sliderY.classList.remove('active-range-circle')

      FacetFiltersForm.sliderTrackHandler(rangeSliders, rangeSliders[0].value, rangeSliders[1].value);
  }

  static sliderTrackHandler(rangeSliders, valueX, valueY) {
      let sliderMaxValue = rangeSliders[1].max;
      let percent1 = ((valueX / sliderMaxValue) * 100);
      let percent2 = ((valueY / sliderMaxValue) * 100);

      document.querySelector(".range-slider-track").style.background = `linear-gradient(to right, var(--range-line) ${percent1}% , var(--range-circle) ${percent1}% , var(--range-circle) ${percent2}%, var(--range-line) ${percent2}%)`;
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const inputBox = document.querySelectorAll(".filter__input-box");
    inputBox.forEach(function(e){
      if(e.checked == true ){
        e.closest(".custom_label-name").classList.add("custom__label-style");
      }
      else if(e.checked == false){
        e.closest(".custom_label-name").classList.remove("custom__label-style");
      }
    })
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    FacetFiltersForm.DemoSlider()
    FacetFiltersForm.hadnlePriceRangeEvent()
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }


  static DemoSlider(){
    let pf_input_desktop = document.querySelector('.rander-slider-values-dekstop')
    let pf_input_mobile = document.querySelector('.rander-slider-values-mobile')
    
    let pf_range_desktop = document.querySelector('.range-slider-container-desktop')
    let pf_range_mobile = document.querySelector('.range-slider-container-mobile')
    
    let pf_track_desktop = document.querySelector('.range-slider-track-desktop')
    let pf_track_mobile = document.querySelector('.range-slider-track-mobile')
  
    let pf_className = {
      input: 'rander-slider-values',
      range: 'range-slider-container',
      track: 'range-slider-track'
    }
  
  
    if(screen.width >= 769){
      // dektop
      pf_input_desktop.classList.add(pf_className.input)
      pf_input_mobile.classList.remove(pf_className.input)
      
      pf_range_desktop.classList.add(pf_className.range)
      pf_range_mobile.classList.remove(pf_className.range)
      
      pf_track_desktop.classList.add(pf_className.track)
      pf_track_mobile.classList.remove(pf_className.track)
    }else {
      // mobile
      pf_input_desktop.classList.remove(pf_className.input)
      pf_input_mobile.classList.add(pf_className.input)
      
      pf_range_desktop.classList.remove(pf_className.range)
      pf_range_mobile.classList.add(pf_className.range)
      
      pf_track_desktop.classList.remove(pf_className.track)
      pf_track_mobile.classList.add(pf_className.track)
    }
  }
  
  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
